'use strict';

const $ = window.jQuery;
import Swiper from 'swiper';

export default class FrontPage {
    constructor() {
        if ( $( '.page-template-front-page' ).length <= 0 ) {
            return;
        }

        // Products
        const productsSlider = new Swiper( '#productsSlider', {
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 600,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            navigation: {
                prevEl: '#productsSliderPrev',
                nextEl: '#productsSliderNext',
            },
            breakpoints: {
                767: {
                    slidesPerView: 2,
                    spaceBetween: 45,
                },
            },
        } );

        // Ambitions
        $( '.home-ambitions__nav' ).on( 'mouseenter', function() {
            if ( ! $( this ).hasClass( 'is-active' ) ) {
                $( '.home-ambitions__nav' ).removeClass( 'is-active' );
                $( this ).addClass( 'is-active' );

                $( '.home-ambitions__item' ).addClass( 'disabled' );

                setTimeout( () => {
                    $( '.home-ambitions__item' ).removeClass( 'is-active' );
                    $( `#ambition-${ $( this ).data( 'item' ) }` ).addClass( 'is-active' );
                    $( '.home-ambitions__item' ).removeClass( 'disabled' );
                }, 200 );
            }
        } );

        // Clients
        const clientsSlider = new Swiper( '#clientsSlider', {
            slidesPerView: 2,
            spaceBetween: 20,
            speed: 600,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                prevEl: '#clientsSliderPrev',
                nextEl: '#clientsSliderNext',
            },
            breakpoints: {
                767: {
                    slidesPerView: 4,
                    spaceBetween: 80,
                },
            },
        } );

        // Welcome ball
        $( window ).on( 'scroll', function() {
            let scroll = $( window ).scrollTop();

            $( '#ballWelcome' ).css( 'transform', `translate3d(${ scroll / 2 }px, ${ scroll / 1.5 }px, 0)` );
        } );
    }
}
